/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchEvidenceResponse } from './MatchEvidenceResponse';
import {
    MatchEvidenceResponseFromJSON,
    MatchEvidenceResponseFromJSONTyped,
    MatchEvidenceResponseToJSON,
    MatchEvidenceResponseToJSONTyped,
} from './MatchEvidenceResponse';

/**
 * 
 * @export
 * @interface ScoreSubmissionResponse
 */
export interface ScoreSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof ScoreSubmissionResponse
     */
    submittedBy: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreSubmissionResponse
     */
    participantId: string;
    /**
     * 
     * @type {number}
     * @memberof ScoreSubmissionResponse
     */
    participant1Score: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreSubmissionResponse
     */
    participant2Score: number;
    /**
     * 
     * @type {Array<MatchEvidenceResponse>}
     * @memberof ScoreSubmissionResponse
     */
    evidence: Array<MatchEvidenceResponse>;
    /**
     * 
     * @type {number}
     * @memberof ScoreSubmissionResponse
     */
    submittedAt: number;
}

/**
 * Check if a given object implements the ScoreSubmissionResponse interface.
 */
export function instanceOfScoreSubmissionResponse(value: object): value is ScoreSubmissionResponse {
    if (!('submittedBy' in value) || value['submittedBy'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('participant1Score' in value) || value['participant1Score'] === undefined) return false;
    if (!('participant2Score' in value) || value['participant2Score'] === undefined) return false;
    if (!('evidence' in value) || value['evidence'] === undefined) return false;
    if (!('submittedAt' in value) || value['submittedAt'] === undefined) return false;
    return true;
}

export function ScoreSubmissionResponseFromJSON(json: any): ScoreSubmissionResponse {
    return ScoreSubmissionResponseFromJSONTyped(json, false);
}

export function ScoreSubmissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreSubmissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'submittedBy': json['submittedBy'],
        'participantId': json['participantId'],
        'participant1Score': json['participant1Score'],
        'participant2Score': json['participant2Score'],
        'evidence': ((json['evidence'] as Array<any>).map(MatchEvidenceResponseFromJSON)),
        'submittedAt': json['submittedAt'],
    };
}

export function ScoreSubmissionResponseToJSON(json: any): ScoreSubmissionResponse {
    return ScoreSubmissionResponseToJSONTyped(json, false);
}

export function ScoreSubmissionResponseToJSONTyped(value?: ScoreSubmissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submittedBy': value['submittedBy'],
        'participantId': value['participantId'],
        'participant1Score': value['participant1Score'],
        'participant2Score': value['participant2Score'],
        'evidence': ((value['evidence'] as Array<any>).map(MatchEvidenceResponseToJSON)),
        'submittedAt': value['submittedAt'],
    };
}

